import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Input,
  InputGroup,
  ModalInfo,
  ModalInfoProps,
} from '@/components';
import { useInputText } from '@/hooks';
import { Validation } from '@/models';
import { CreateReflinkRequest } from '@/api';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { profileActions } from '@/redux/actions';
import { profileSelectors } from '@/redux/selectors';
import styles from './YourReferralLinksCreateModal.module.sass';

interface YourReferralLinksCreateModalProps extends ModalInfoProps {}

const YourReferralLinksCreateModal: FC<YourReferralLinksCreateModalProps> = (
  props,
) => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(profileSelectors.getProfileSlice);
  const [finished, setFinished] = useState(false);
  const TITLE_VALIDATIONS: Validation[] = useMemo(() => [], []);
  const titleField = useInputText('', TITLE_VALIDATIONS);

  useEffect(() => {
    if (finished === loading) return;

    if (finished && finished !== loading) {
      onClose();
    }

    setFinished(loading);
  }, [loading]);

  const handleSubmit = () => {
    if (!loading) {
      const payload: CreateReflinkRequest = {
        title: titleField.value,
      };
      dispatch(profileActions.createReflink(payload));
    }
  };

  return (
    <ModalInfo
      isOpen={isOpen}
      title={t('translation.create_new_referral')}
      actions={
        <>
          <Button type="primary" corner="rect" onClick={handleSubmit}>
            {t('translation.create_new_reflink_btn')}
          </Button>
          <Button type="secondary" corner="rect" onClick={onClose}>
            {t('translation.cancel_btn')}
          </Button>
        </>
      }
      className={styles.modal}
      onClose={onClose}
    >
      <div className={styles.list}>
        <InputGroup label={t('translation.referral_name_lbl')}>
          <Input
            id="name"
            name="name"
            type="text"
            value={titleField.value}
            onBlur={() => {}}
            onChange={titleField.onChange}
          />
        </InputGroup>
      </div>
    </ModalInfo>
  );
};

export default YourReferralLinksCreateModal;
